// src/components/PaymentStatus.js
import React from 'react';

export const PaymentSuccess = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f4f4f4'
    }}>
        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
            <h1 style={{ color: '#28a745', fontSize: '48px', marginBottom: '20px' }}>Payment Successful</h1>
            <p>Thank you for your purchase! Your order is being processed.</p>
            <a href="/" style={{ display: 'block', marginTop: '20px', color: '#000', textDecoration: 'underline' }}>Return to Home</a>
        </div>
    </div>
);

export const PaymentFailed = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f4f4f4'
    }}>
        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
            <h1 style={{ color: '#dc3545', fontSize: '48px', marginBottom: '20px' }}>Payment Failed</h1>
            <p>Oops! Something went wrong with your payment. Please try again.</p>
            <a href="/" style={{ display: 'block', marginTop: '20px', color: '#000', textDecoration: 'underline' }}>Return to Home</a>
        </div>
    </div>
);
